import type { RunStatus } from "../hooks/useStreamingText";
import type { StatusState } from "./chatStatus";

/**
 * Decides whether to release the next queued chat message. Dispatch is allowed
 * only on a fresh, explicit run-completion edge (`runCompletions` past the value
 * we last dispatched at) while the chat is in a *stable* resting state. This
 * keeps a transient `respondingAt → null` flicker (which momentarily derives
 * `statusState === "resting"` mid-reconciliation) from firing the queue, and
 * keeps an in-flight run from being overlapped.
 */
export function shouldDispatchQueued(params: {
  statusState: StatusState;
  runStatus: RunStatus;
  isResponding: boolean;
  queueLength: number;
  runCompletions: number;
  lastDispatchedCompletion: number;
}): boolean {
  const isStableResting =
    params.statusState === "resting" &&
    params.runStatus === "idle" &&
    !params.isResponding;
  if (!isStableResting) return false;
  if (params.queueLength === 0) return false;
  return params.runCompletions !== params.lastDispatchedCompletion;
}
